import * as Types from '../../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubscriptionMatchQueryVariables = Types.Exact<{
  input: Types.JobAlertSubscriptionMatchInput;
}>;


export type SubscriptionMatchQuery = { __typename?: 'Query', jobAlert?: { __typename?: 'JobAlertQueries', subscriptionMatch?: { __typename?: 'JobAlertSubscriptionMatchResult', subscriptionState?: Types.SubscriptionState | null, subscriptionId?: string | null } | null } | null };


export const SubscriptionMatchDocument = gql`
    query SubscriptionMatch($input: JobAlertSubscriptionMatchInput!) {
  jobAlert {
    subscriptionMatch(input: $input) {
      subscriptionState
      subscriptionId
    }
  }
}
    `;

/**
 * __useSubscriptionMatchQuery__
 *
 * To run a query within a React component, call `useSubscriptionMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionMatchQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscriptionMatchQuery(baseOptions: Apollo.QueryHookOptions<SubscriptionMatchQuery, SubscriptionMatchQueryVariables> & ({ variables: SubscriptionMatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionMatchQuery, SubscriptionMatchQueryVariables>(SubscriptionMatchDocument, options);
      }
export function useSubscriptionMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionMatchQuery, SubscriptionMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionMatchQuery, SubscriptionMatchQueryVariables>(SubscriptionMatchDocument, options);
        }
export function useSubscriptionMatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubscriptionMatchQuery, SubscriptionMatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubscriptionMatchQuery, SubscriptionMatchQueryVariables>(SubscriptionMatchDocument, options);
        }
export type SubscriptionMatchQueryHookResult = ReturnType<typeof useSubscriptionMatchQuery>;
export type SubscriptionMatchLazyQueryHookResult = ReturnType<typeof useSubscriptionMatchLazyQuery>;
export type SubscriptionMatchSuspenseQueryHookResult = ReturnType<typeof useSubscriptionMatchSuspenseQuery>;
export type SubscriptionMatchQueryResult = Apollo.QueryResult<SubscriptionMatchQuery, SubscriptionMatchQueryVariables>;